import React from 'react';
import type { FieldConfig } from '../types/forms';
type FormFieldProps = {
  id: string;
  field: FieldConfig;
  value: string;
  error?: string;
  className?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
};
export function FormField({
  id,
  field,
  value,
  error,
  className = '',
  onChange,
  onBlur
}: FormFieldProps) {
  const errorId = `${id}-error`;
  const type = field.type ?? 'text';
  const a11y = {
    id,
    name: field.name,
    required: field.required,
    'aria-invalid': error ? true : undefined,
    'aria-describedby': error ? errorId : undefined,
    onBlur
  };
  const control = `mt-2 block w-full rounded-sm border bg-white px-4 py-3 text-[15px] text-ink transition-[border-color,box-shadow] duration-150 ease-out focus:outline-none focus:ring-2 ${error ? 'border-danger focus:border-danger focus:ring-danger/20' : 'border-ink/15 focus:border-gold focus:ring-gold/30'}`;
  const errorText = error && <p id={errorId} className="mt-2 text-sm text-danger" data-id="element-161" data-mp="2y0j1221qwpx8">
      {error}
    </p>;
  if (type === 'checkbox') {
    return <div className={className} data-id="element-162" data-mp="1eclxh34nkkgh">
        <label htmlFor={id} className="flex cursor-pointer items-start gap-3" data-id="element-163" data-mp="1ednh3vzqif9t">
          <input {...a11y} type="checkbox" checked={value === 'yes'} onChange={e => onChange(e.target.checked ? 'yes' : '')} className="mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded-sm border-ink/30 accent-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-164" data-mp="1jb5govrv3i55" />
          <span className="text-sm leading-relaxed text-ink/80" data-id="element-165" data-mp="222pwex6wbw15">
            {field.label}
            {field.required && <span className="text-ink/50" aria-hidden="true" data-id="element-166" data-mp="2722ivgtuv137">
                {' '}*
              </span>}
          </span>
        </label>
        {errorText}
      </div>;
  }
  return <div className={className} data-id="element-167" data-mp="2g1pj3zaum0uo">
      <label htmlFor={id} className="text-sm font-medium text-ink" data-id="element-168" data-mp="2g2qyuh2t7biq">
        {field.label}
        {field.required ? <span className="text-ink/50" aria-hidden="true" data-id="element-169" data-mp="fxveyn5ighee">
            {' '}*
          </span> : <span className="ml-1.5 text-xs font-normal text-ink/50" data-id="element-170" data-mp="pq18407i14v6">(optional)</span>}
      </label>

      {type === 'textarea' ? <textarea {...a11y} rows={5} value={value} onChange={e => onChange(e.target.value)} className={`${control} resize-y`} data-id="element-171" data-mp="ky9o68iulxe0" /> : type === 'select' ? <select {...a11y} value={value} onChange={e => onChange(e.target.value)} className={`${control} cursor-pointer appearance-none bg-[length:16px] bg-[right_1rem_center] bg-no-repeat pr-10`} style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2317243A' stroke-width='1.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")"
    }} data-id="element-172" data-mp="uom6du36xegz">
          <option value="" data-id="element-173" data-mp="1kzwmtcymk9qj">Select an option</option>
          {field.options?.map(opt => <option key={opt} value={opt} data-id="element-174" data-mp="1pxg1gdz8ioj0">
              {opt}
            </option>)}
        </select> : <input {...a11y} type={type} value={value} autoComplete={field.autoComplete} onChange={e => onChange(e.target.value)} className={control} data-id="element-175" data-mp="1c5049tt0lkq0" />}
      {errorText}
    </div>;
}